
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/franchise-list-page/[slug]",
      function () {
        return require("private-next-pages/well/franchise-list-page/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/franchise-list-page/[slug]"])
      });
    }
  